import { getEnv } from './env';

export const isDemoMode = getEnv('REACT_APP_ENV') === "DEMO";
